"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserSchema = exports.createUserSchema = exports.authResponseSchema = exports.userSchema = exports.loginSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
exports.loginSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(1),
});
exports.userSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    email: zod_1.z.string().email(),
    fullName: zod_1.z.string(),
    role: zod_1.z.enum(enums_js_1.UserRoles),
    active: zod_1.z.boolean(),
    lastLoginAt: zod_1.z.string().datetime().nullable().optional(),
});
exports.authResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    expiresAt: zod_1.z.string().datetime(),
    user: exports.userSchema,
});
exports.createUserSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    fullName: zod_1.z.string().min(1).max(200).trim(),
    role: zod_1.z.enum(enums_js_1.UserRoles),
    password: zod_1.z.string().min(8).max(128),
});
exports.updateUserSchema = zod_1.z.object({
    fullName: zod_1.z.string().min(1).max(200).trim().optional(),
    role: zod_1.z.enum(enums_js_1.UserRoles).optional(),
    active: zod_1.z.boolean().optional(),
    password: zod_1.z.string().min(8).max(128).optional(),
});
//# sourceMappingURL=auth.js.map